import React from "react";
import style from "./index.module.scss";
import { Modal } from "antd";
import { SysMessage } from "API";
import moment from "moment";

interface NoticeModalProps {
    visible: boolean; //显示与隐藏的状态
    onCancel: () => void; //取消
    data: SysMessage;
}

export default function NoticeModal({
    visible,
    onCancel,
    data
}: NoticeModalProps) {
    return (
        <Modal
            visible={visible}
            title="通知内容"
            className={style.root}
            maskClosable={false}
            onCancel={onCancel}
            footer={null}
            width={1200}>
            <div className={style.header}>
                <div className={style.title}>{data.title}</div>
                <div className={style.time}>
                    {moment(data.createTime).format("YYYY-MM-DD HH:mm")}
                </div>
            </div>

            <div className={style.container}>
                <div
                    className={style.title}
                    dangerouslySetInnerHTML={{ __html: data.content }}
                />
            </div>

            <div className={style.footer}>
                <div>{data.createUser}</div>
                <div>{moment(data.createTime).format("YYYY年MM月DD日")}</div>
            </div>
        </Modal>
    );
}
